namespace RioERP.Web.Enums {
    export enum EBookStatus {
        Added = 1,
        NotAdded = 2,
        AllBooksAdded = 3,
        AllSpecificationsBooksAdded = 4
    }
    Serenity.Decorators.registerEnumType(EBookStatus, 'RioERP.Web.Enums.EBookStatus');
}
